// extracted by mini-css-extract-plugin
export default {"resourceCard":"resourceCard_resourceCard__xb4Av","animatedTitle":"resourceCard_animatedTitle__0Fcwd","slideForward":"resourceCard_slideForward__Rs5R5"};